import React from 'react'

import { IdGen } from 'utils'

import { ZariContext } from '_zari/context'

import { Col, Row, Modal, Button } from '_zari/core'

import ProcesoFormGroup from './formGroups/proceso'

import * as GuiasVentaHistorialService from 'services/guiasVentaHistorial.service'

const NuevoPrecioLista = ({ handleClose, show, docId, refreshTable }) => {
  const __zariContext = React.useContext(ZariContext)
  const [proceso, setProceso] = React.useState('')
  const [cargando, setCargando] = React.useState(false)
  const [nuevaLlave, setNuevaLlave] = React.useState(IdGen.newId())

  const submitHandler = () => {
    if (proceso === 'ENVIAR') {
      setCargando(true)
      setNuevaLlave(IdGen.newId())
      GuiasVentaHistorialService.enviarDocumentosxIds({ ids: docId })
        .then(() => {
          __zariContext.snack('success', 'El documento se ha enviado.')
          handleClose()
          refreshTable()
          setCargando(false)
          setNuevaLlave(IdGen.newId())
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setCargando(false)
          setNuevaLlave(IdGen.newId())
        })
    } else {
      __zariContext.snack('error', 'Proceso incorrecto.')
    }
  }

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>ENVIAR DOCUMENTO</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <ProcesoFormGroup value={proceso} onChange={e => setProceso(e.target.value)} />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button color='secondary' onClick={handleClose}>
            Cancelar
          </Button>
          <Button key={nuevaLlave} onClick={submitHandler} disabled={cargando}>
            {cargando ? '...Enviando' : 'Enviar'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default NuevoPrecioLista
